export default __webpack_public_path__ + "static/media/circle_check.78c4122b.svg";